export default "__VITE_ASSET__jyjPWN_y__"